import type { IProperty } from '@/domain/entities/property';
import type { PropertiesState } from './propertyTypes';

/**
 * Drops cached handover details for Properties that are no longer in a handover. Details are
 * never rebuilt from Property data: they come only from the initiate response or the
 * `properties:handover`-authorized active-handover operation.
 */
export function clearSettledHandovers(state: PropertiesState, props: IProperty[]) {
  for (const p of props) {
    if (!p?.id || p.status === 'handoverInitiated') continue;
    delete state.handoverById[p.id];
    delete state.handoverInitiatingById[p.id];
    delete state.handoverErrorById[p.id];
  }
}
